import { Instruction } from 'packages/lib/api/annotations/contract/instruction';
import { SampleGroup } from 'packages/lib/api/annotations/contract/sample-group';
import { Task } from 'packages/lib/api/annotations/contract/task';
import { TaskGroup } from 'packages/lib/api/annotations/contract/task-group';
import { atom, selector } from 'recoil';
import { getSiblingLidarboxTasks } from 'packages/lib/api/annotations/fetch/tasks';
import { taskTypeZod } from 'packages/lib/api/annotations/contract/enums';
import { TaskQueue } from 'packages/task-man/service/pickup';

export const taskQueueAtom = atom<TaskQueue | null | undefined>({
  key: 'task-queue-atom',
  default: undefined,
});

export const taskAtom = atom<Task | undefined | null>({
  key: 'annotation-tool-task-atom',
  default: undefined,
});

export const siblingLidarboxTaskSeletor = selector<Task | undefined | null>({
  key: 'sibling-lidarbox-task-selector',
  get: async ({ get }) => {
    const task = get(taskAtom);
    if (!task) {
      return undefined;
    }
    const lidarboxTask = await getSiblingLidarboxTasks(task).then((tasks) =>
      tasks.find((t) => t.type === taskTypeZod.enum.LidarBox)
    );
    return lidarboxTask;
  },
});

export const taskGroupAtom = atom<TaskGroup | undefined | null>({
  key: 'annotation-tool-task-group-atom',
  default: undefined,
});

export const sampleGroupAtom = atom<SampleGroup | undefined | null>({
  key: 'annotation-tool-sample-group-atom',
  default: undefined,
});

export const instructionAtom = atom<Instruction | undefined | null>({
  key: 'annotation-tool-instruction-atom',
  default: undefined,
});

export const toolAliasAtom = atom<string | undefined | null>({
  key: 'tool-alias-atom',
  default: undefined,
});

export const numFramesAtom = atom<number | undefined | null>({
  key: 'num-frames-atom',
  default: 1,
});

export const numObjectsAtom = atom<number | undefined | null>({
  key: 'num-objects-atom',
  default: 0,
});
